module.exports = __webpack_public_path__ + "static/media/alycore03.f5ff0004.png";